import { render, staticRenderFns } from "./base-data.vue?vue&type=template&id=47649e90&scoped=true"
import script from "./base-data.vue?vue&type=script&lang=js"
export * from "./base-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47649e90",
  null
  
)

export default component.exports